import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
 import Button from'../ui/Button';
 import Input from'../ui/Input';

const Signup = () => {
  const { signUp } = useAuth()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    fullName: '',
    confirmPassword: ''
  })
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(false)

  const handleSubmit = async (e) => {
    e?.preventDefault()
    setLoading(true)
    setError(null)

    // Validate passwords match
    if (formData?.password !== formData?.confirmPassword) {
      setError('Die Passwörter stimmen nicht überein.')
      setLoading(false)
      return
    }

    // Validate password length
    if (formData?.password?.length < 6) {
      setError('Das Passwort muss mindestens 6 Zeichen lang sein.')
      setLoading(false)
      return
    }

    const { user, error: signUpError } = await signUp(
      formData?.email,
      formData?.password,
      { fullName: formData?.fullName }
    )

    if (signUpError) {
      setError(signUpError)
    } else {
      setSuccess(true)
    }

    setLoading(false)
  }

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e?.target?.name]: e?.target?.value
    }))
    // Clear error when user starts typing
    if (error) setError(null)
  }

  if (success) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h3 className="text-2xl font-bold text-green-600 mb-4">
              Registrierung erfolgreich!
            </h3>
            <p className="text-gray-600 mb-6">
              Vielen Dank für Ihre Registrierung bei AdvoCall. 
              Sie können sich jetzt anmelden und unsere Services nutzen.
            </p>
            <Button
              onClick={() => navigate('/login')}
              variant="default"
              className="bg-trust-builder hover:bg-trust-builder/90 text-white"
            >
              Zur Anmeldung
            </Button>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Registrierung bei AdvoCall
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Erstellen Sie Ihr Konto für rechtliche Beratung
          </p>
        </div>
        
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="space-y-4">
            <Input
              label="Vollständiger Name"
              type="text"
              name="fullName"
              value={formData?.fullName}
              onChange={handleChange}
              required
              placeholder="Ihr vollständiger Name"
            />

            <Input
              label="E-Mail-Adresse"
              type="email"
              name="email"
              value={formData?.email}
              onChange={handleChange}
              required
              placeholder="ihre.email@beispiel.de"
            />

            <Input
              label="Passwort"
              type="password"
              name="password"
              value={formData?.password}
              onChange={handleChange}
              required
              placeholder="Mindestens 6 Zeichen"
              minLength={6}
            />

            <Input
              label="Passwort bestätigen"
              type="password"
              name="confirmPassword"
              value={formData?.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Passwort wiederholen"
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-md p-4">
              <div className="flex">
                <div className="text-sm text-red-700">
                  {error}
                </div>
              </div>
            </div>
          )}

          <div>
            <Button
              type="submit"
              variant="default"
              size="lg"
              loading={loading}
              className="w-full bg-conversion-accent hover:bg-conversion-accent/90 text-white"
            >
              {loading ? 'Wird registriert...' : 'Registrieren'}
            </Button>
          </div>
        </form>

        <div className="text-center">
          <p className="text-sm text-gray-600">
            Bereits ein Konto?{' '}
            <button
              type="button"
              onClick={() => navigate('/login')}
              className="font-medium text-primary hover:text-primary/80"
            >
              Hier anmelden
            </button>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Signup